export enum SectionTitleDataHooks {
  LABEL = 'label',
  DIVIDER = 'divider',
}
